
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {translate} from "@/auxillary/translation";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'DecimalField',
  components: {
    DataFieldBar,
    OkDialog,
    Hints
  },
})
export default class DecimalField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";


  get labelField() {
    return this.displayName.length <= 9 ? this.displayName : ""
  }

  get labelAbove() {
    return this.displayName.length > 9 ? this.displayName : ""
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isRequired() {
    return this.dataField.isRequired
  }

  get isReadonly() {
    return !this.field.isEditable;
  }

  get value() {
    this.validateInput()
    const value = this.dataField.values.value;
    return (value === "unknown" || !value || isNaN(parseFloat(value.replace(this.decimalSeparator, ".")))) ? "" : this.normalizeFloatValue(value)
  }

  set value(value: string) {
    this.validateInput()
    if (!isNaN(parseFloat(value.replace(this.decimalSeparator, ".")))) {
      value = this.normalizeFloatValue(value);
      dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
    }
  }

  normalizeFloatValue(value: string): string {
    return parseFloat(value.replace(this.decimalSeparator, ".")).toString().replace('.', this.decimalSeparator)
  }

  updateValue() {
    let value = "";
    if (this.unknown && this.canBeUnknown)
      value = "unknown";
    this.value = value;
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  set unknown(value: boolean) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "unknown", value})
    this.updateValue()
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return 100 + (Math.max(this.suffix.length - 5, 0) * 8);
  }

  get suffix() {
    return translate(this.field.definition.unit, "unit") ?? "";
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

  get decimalSeparator() {
    return this.field.definition.decimalSeparator || ',';
  }

  validateKeyPress(evt: KeyboardEvent) {
    let keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'];
    const keyPressed: string = evt.key;

    const value = this.dataField.values?.value;
    if (!value || (value && this.decimalSeparator && value.indexOf(this.decimalSeparator) == -1)) {
      keysAllowed.push(this.decimalSeparator)
    }

    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  validateInput() {
    const value = this.dataField.values?.value;
    if (value) {
      const floatValue = Number.parseFloat(value.replace(this.decimalSeparator, "."));
      if (this.minValue) {
        if (floatValue < this.minValue) {
          this.errorMessage = "Minimalwert: " + this.minValue;
          return;
        }
      }
      if (this.maxValue) {
        if (floatValue > this.maxValue) {
          this.errorMessage = "Maximalwert: " + this.maxValue;
          return;
        }
      }
    }
    this.errorMessage = "";
  }
}
